import React from "react";
import './footer.scss';

export function Footer() {
    return(
        <footer>
            <p>Виконано в <a href="https://prometheus.org.ua/" target="_blank">Prometheus</a> © 2022</p>
        </footer>
    );
}